// Funkcja tłumacząca komunikaty błędów Firebase na polskie odpowiedniki
export const translateFirebaseError = (errorCode, context = 'general') => {
  const errorMessages = {
    'auth/user-not-found': 'Nie znaleziono użytkownika z podanym adresem email',
    'auth/wrong-password': 'Nieprawidłowe hasło',
    'auth/invalid-email': 'Nieprawidłowy format adresu email',
    'auth/user-disabled': 'Konto zostało wyłączone',
    'auth/too-many-requests': 'Zbyt wiele prób logowania. Spróbuj ponownie później',
    'auth/network-request-failed': 'Błąd połączenia sieciowego',
    'auth/operation-not-allowed': 'Operacja logowania nie jest dozwolona',
    'auth/invalid-credential': 'Nieprawidłowe dane logowania',
    'auth/account-exists-with-different-credential': 'Konto istnieje z innymi danymi uwierzytelniającymi',
    'auth/requires-recent-login': 'Wymagane jest ponowne logowanie',
    'auth/weak-password': 'Hasło jest zbyt słabe',
    'auth/email-already-in-use': 'Ten adres email jest już używany',
    'auth/invalid-verification-code': 'Nieprawidłowy kod weryfikacyjny',
    'auth/invalid-verification-id': 'Nieprawidłowy identyfikator weryfikacji',
    'auth/quota-exceeded': 'Przekroczono limit żądań',
    'auth/credential-already-in-use': 'Te dane uwierzytelniające są już używane',
    'auth/timeout': 'Przekroczono limit czasu operacji',
    'auth/cancelled-popup-request': 'Anulowano żądanie popup',
    'auth/popup-blocked': 'Popup został zablokowany przez przeglądarkę',
    'auth/popup-closed-by-user': 'Popup został zamknięty przez użytkownika',
    'auth/unauthorized-domain': 'Nieautoryzowana domena',
    'auth/app-not-authorized': 'Aplikacja nie jest autoryzowana',
    'auth/argument-error': 'Błąd argumentu',
    'auth/invalid-app-credential': 'Nieprawidłowe dane uwierzytelniające aplikacji',
    'auth/invalid-user-token': 'Nieprawidłowy token użytkownika',
    'auth/invalid-tenant-id': 'Nieprawidłowy identyfikator najemcy',
    'auth/tenant-id-mismatch': 'Niezgodność identyfikatora najemcy',
    'auth/unsupported-persistence-type': 'Nieobsługiwany typ trwałości',
    'auth/unsupported-tenant-operation': 'Nieobsługiwana operacja najemcy',
    'auth/user-token-expired': 'Token użytkownika wygasł',
    'auth/web-storage-unsupported': 'Przechowywanie web nie jest obsługiwane',
    'auth/operation-not-supported-in-this-environment': 'Operacja nie jest obsługiwana w tym środowisku',
    'auth/recaptcha-not-enabled': 'reCAPTCHA nie jest włączona',
    'auth/missing-recaptcha-token': 'Brak tokenu reCAPTCHA',
    'auth/invalid-recaptcha-token': 'Nieprawidłowy token reCAPTCHA',
    'auth/invalid-recaptcha-action': 'Nieprawidłowa akcja reCAPTCHA',
    'auth/missing-client-type': 'Brak typu klienta',
    'auth/missing-recaptcha-version': 'Brak wersji reCAPTCHA',
    'auth/invalid-recaptcha-version': 'Nieprawidłowa wersja reCAPTCHA',
    'auth/invalid-req-type': 'Nieprawidłowy typ żądania'
  };

  // Domyślne komunikaty w zależności od kontekstu
  const defaultMessages = {
    'login': 'Wystąpił nieznany błąd podczas logowania',
    'register': 'Hasło musi składać się z 8 znaków, zawierać małą i dużą literę oraz cyfrę',
    'reset-password': 'Wystąpił nieznany błąd podczas resetowania hasła',
    'google-login': 'Wystąpił nieznany błąd podczas logowania Google',
    'general': 'Wystąpił nieznany błąd'
  };

  return errorMessages[errorCode] || defaultMessages[context] || defaultMessages['general'];
};
